import {copyArr} from '../../util';

export default {
    data() {return {
        mx_sort_fields : [],
        mx_sort_forced : []
    }},
    methods : {
        mx_outerSort(sortOrder) {
            this.mx_syncSort(sortOrder);
            this.mx_buildData();
        },
        mx_syncSort(sortOrder) {
            // 1. Reset previous
            this.mx_fieldsInfo.forEach((field) => {
                field.__sortOrder = '';
            })
            // 2. Build sort order info. array
            var arr = [];
            if(Array.isArray(sortOrder)) {
                sortOrder.forEach(s => {
                    // 2.1 Find field via map
                    var field = this.mx_fieldMap.get(s.value);
                    if(!field) return;
                    // 2.2 Check order is available
                    if(s.__sortOrder!=='A' && s.__sortOrder!=='D') {
                        return;
                    }
                    // 2.3 Push to order array
                    field.__sortOrder = s.__sortOrder;
                    arr.push(field);
                })
            }
            // 3. set to global variable
            this.mx_sort_fields = arr;
            return arr;// 이거 쓸데가 없어보이는데? 
        },
        mx_sort_toggleField(c, dir) {
            // 1. get Field
            let field = c;
            if(typeof c === 'string') {
                // fieldMap : urDataGridMixin
                field  = this.mx_fieldMap.get(c);
            }
            if(!field) return;
            // 2. check option
            if(!field.__isSort) return
            // 3. check It's forced field or not
            //var grpIdx = this.mx_options.grouping.indexOf(c.value);
            if( field.__isGroup >= 0 ) {
                // 3.1 It's a group field -> only change order
                //var f = this.mx_sort_forced[grpIdx];
                if( dir !== undefined) {
                    field.__sortOrder=dir;
                } else if(field.__sortOrder==='') {
                    field.__sortOrder='A';
                } else if(field.__sortOrder==='A') {
                    field.__sortOrder='D';
                } else if(field.__sortOrder==='D') {
                    field.__sortOrder='';
                }
            } else {
                // 3.2 set flag ['' > 'A' > 'D']
                // 3.2.1 remove from array
                this.mx_sort_fields.find((x, i) => {
                    if(x.value !== field.value) {return false;}
                    this.mx_sort_fields.splice(i,1);
                    return true;
                })
                // 3.2.2 change status(sort order) and append first
                if( dir !== undefined) { // 리펙토링 가능?
                    field.__sortOrder=dir;
                    if(dir==='A' || dir==='D') {
                        this.mx_sort_fields.unshift(field);
                    }
                } else if(field.__sortOrder==='') {
                    field.__sortOrder='A';
                    this.mx_sort_fields.unshift(field);
                } else if(field.__sortOrder==='A') {
                    field.__sortOrder='D';
                    this.mx_sort_fields.unshift(field);
                } else if(field.__sortOrder==='D') {
                    field.__sortOrder='';
                }
            }
            // x. sort data
            this.mx_sort_sortData();
        },
        mx_sort_sortData() {
            // urCommonGridCellActMixin.js
            this.mx_clearCellSelect();
            
            if(!this.mx_options.externalSort) {
                this.mx_buildData();
            }
            this.mx_fireEvent("sorted",this.mx_sort_fields.map(s=>{return {value:s.value, __sortOrder:s.__sortOrder}}))
        }
    }
}